$(document).ready(function(){

    $(document).on("click", ".custom_price_options input", function() {
        if($('.tag_price').length > 0){
            var price_selected = $('.tag_price').html();
            var selected_price_tag = '$' + price_selected.substring(price_selected.indexOf('$') + 1);
            var selected_price_under50 = price_selected.substring(price_selected.indexOf('</a>') + 4).trim();    
    
            if($('.custom_price_options label:first-child input').is(':checked') && $('.tag_price:contains("Under $50")')) {    
                if (selected_price_under50 == 'Under $50') {
                    $('.tag_price:contains("Under $50") a')[0].click();
                }        
            }
            if($('.custom_price_options label:nth-child(2) input').is(':checked') && $('.tag_price:contains("$50 - $100")')) {         
                if (selected_price_tag == '$50 - $100') {
                    $('.tag_price:contains("$50 - $100") a')[0].click();
                }
            }    
            if($('.custom_price_options label:nth-child(3) input').is(':checked') && $('.tag_price:contains("$100-")')) {        
                if (selected_price_tag == '$100 - $150') {
                    $('.tag_price:contains("$100-") a')[0].click();
                }            
            }        
            if($('.custom_price_options label:nth-child(4) input').is(':checked')) {        
                if (selected_price_tag == '$150 - $200 ') {
                    $('.tag_price a')[0].click();
                }           
            }        
            if($('.custom_price_options label:nth-child(5) input').is(':checked')) {             
                if (selected_price_under50 == 'Over $200') {
                    $('.tag_price a')[0].click();
                }                
            }
        } 
    });
    
    $(".size-chart-open-popup").magnificPopup({ type: "inline", midClick: !0 }),
    $(".return-policy-open-popup").magnificPopup({ type: "inline", midClick: !0 }),
    $("form#create_customer").submit(function (t) {
        $("#CreatePassword").val() !== $("#CreatePasswordConfirmation").val()
        ? ($(".password_match").fadeIn("slow"), $("#CreatePassword, #CreatePasswordConfirmation").css("border", "2px solid #f00"), t.preventDefault())
        : ($(".password_match").fadeOut("slow"), $("#CreatePassword, #CreatePasswordConfirmation").removeAttr("style")),
        $("#Email").val() !== $("#EmailConfirmation").val()
        ? ($(".email_match").fadeIn("slow"), $("#Email, #EmailConfirmation").css("border", "2px solid #f00"), t.preventDefault())
        : ($(".email_match").fadeOut("slow"), $("#Email, #EmailConfirmation").removeAttr("style"));
    });   
    $(document).on("click", ".toggle_collection_sidebar", function(event) {
        event.preventDefault();
        var $container = $(".product-facet");
        $container.toggleClass("collection-sidebar--opened collection-sidebar--collapsed")
    });
    $(document).on("click", ".shopify-section--main-product .block-swatch-list .block-swatch", function(event) {
        var current_class = $(this).attr('class');
        if(current_class.indexOf('is-disabled') != -1){
           $(this).parents('.product__info').find('#AddToCart').hide();
           $(this).parents('.product__info').find('.pdp_atc_wrap #BIS_trigger').show();
        }
        else{
            $(this).parents('.product__info').find('#AddToCart').show();
            $(this).parents('.product__info').find('.pdp_atc_wrap #BIS_trigger').hide();
        }         
     });
    
    function modifyText() {
        if($('.vendor-block-info').length > 0){
            var VendorTitleHtml =  $('.vendor-block-info').data('attr-vendor-title').split(',');
            var VendorLinkHtml =  $('.vendor-block-info').data('attr-vendor-link').split(',');
            
            var VendorTitleHtml1 =  $('.vendor-block-info1').data('attr-vendor-title').split(',');
            var VendorLinkHtml1 =  $('.vendor-block-info1').data('attr-vendor-link').split(',');
            
            var VendorTitleHtml2 =  $('.vendor-block-info2').data('attr-vendor-title').split(',');
            var VendorLinkHtml2 =  $('.vendor-block-info2').data('attr-vendor-link').split(',');
        
            // Merge all arrays 
            VendorTitleHtml = $.merge($.merge(VendorTitleHtml, VendorTitleHtml1), VendorTitleHtml2);            
            VendorLinkHtml = $.merge($.merge(VendorLinkHtml, VendorLinkHtml1), VendorLinkHtml2);            
            try { localStorage.setItem('rdVendorList', JSON.stringify(VendorTitleHtml.map(function (v) { return String(v).trim(); }))); } catch (e) {} // desktop speed: lets the next product page show the brand line at first paint
            
            $.each(jQuery('.product-item .product-item__info .product-meta__vendor'), function(index, elem) {             
                var textVendorUp =this.innerText.toUpperCase();               
                var vendorArrayPos = VendorTitleHtml.indexOf(textVendorUp);              
                if (vendorArrayPos == -1 || !window.isValue(this.innerText)) {
                   $(this).hide();  
                }        
                if (vendorArrayPos != -1) {
                    var VendorLinkHtmlItem = VendorLinkHtml[vendorArrayPos];                 
                    var buildElement = $(this).text();
                    $(this).html('<a href="'+ VendorLinkHtmlItem + '" class="vendor_link--active">' + buildElement + '</a>');                   
                }        
            });        
          
            $.each(jQuery('.product-meta .product-meta__vendor'), function(index, elem) {             
                var textVendorUp =this.textContent.trim().toUpperCase(); // textContent: the line starts hidden on desktop
                var vendorArrayPos = VendorTitleHtml.indexOf(textVendorUp);
          
                if (vendorArrayPos == -1 || !window.isValue(textVendorUp)) {
                    $(this).hide();  
                }
                if (vendorArrayPos != -1) {
                    $(this).css('display', 'block'); // desktop speed: reveal listed brands (desktop starts with the line hidden)
                    var VendorLinkHtmlItem = VendorLinkHtml[vendorArrayPos];                
                    var buildElement = $(this).text();
                    $(this).html('<a href="'+ VendorLinkHtmlItem + '" class="vendor_link--active">' + buildElement + '</a>');                
                }        
            });        
        }
    }
        
    modifyText(); 

    $(document).on("click",".fs-buy-button",function() {
        setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) {
            jQuery('.header__cart-count span.count').text(cart.item_count);
            let cartData = cart.items;
            document.documentElement.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: cartData
            })); 
            });
        }, 1000);
    });

    $(document).on("click", ".product-item__quick-form button", function() {
        setTimeout(function() {
            $(".size-chart-open-popup").magnificPopup({ type: "inline" });
        }, 1000);
    });
});


function cartRecommendationQuickViewCustom(elementID){
var findElement = jQuery('.mini-cart__recommendations-list-slider').find('#' + elementID);
$('.mini-cart__recommendations').append(findElement);
setTimeout(function() {
    $(".size-chart-open-popup").magnificPopup({ type: "inline" });
}, 1000);
}
// Desktop: center the Back in Stock "Want a Restock?" popup. The app's own CSS makes it 400px wide on
// screens 992px+ but leaves it pinned to the left edge. The popup lives in an iframe (#BIS_frame), so the
// rule is added inside that iframe whenever it is (re)built. Phones are unaffected (same 992px breakpoint as the app).
(function () {
  var CSS = '@media only screen and (min-width: 992px) { #BISModal > .modal { left: 50% !important; transform: translateX(-50%) !important; } }';
  function patch(frame) {
    try {
      var doc = frame.contentDocument;
      if (!doc || !doc.head || doc.getElementById('rd-bis-center')) return;
      var style = doc.createElement('style');
      style.id = 'rd-bis-center';
      style.textContent = CSS;
      doc.head.appendChild(style);
    } catch (e) {}
  }
  function watch(frame) {
    if (frame.__rdWatched) return;
    frame.__rdWatched = true;
    patch(frame);
    frame.addEventListener('load', function () { patch(frame); });
    try { new MutationObserver(function () { patch(frame); }).observe(frame.contentDocument, { childList: true, subtree: true }); } catch (e) {}
  }
  new MutationObserver(function () {
    var frame = document.getElementById('BIS_frame');
    if (frame) watch(frame);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
